export const CONTACT_URL = "https://calendly.com/resolvex/castlet";
export const PLATFORM_URL = "https://dashboard.resolvex.com/";
export const WEB_TITLE = "ResolveX";
